import type { FeatureModule } from './feature-module';
import { pipelineModule } from '../features/pipeline';
import { financeiroModule } from '../features/financeiro';
import { prospectingModule } from '../features/prospecting';
import { aprovacoesModule } from '../features/aprovacoes';

export const features: FeatureModule[] = [
  pipelineModule,
  financeiroModule,
  prospectingModule,
  aprovacoesModule,
];
